import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { formatNumber } from "@progress/kendo-intl";
import * as React from 'react';
import { AssetCarrierViewModel } from "TypeGen/Assets/Carriers/List/asset-carrier-view-model";

type SelectedCarrierValue = {
  CarrierID: number;
  CarrierName: string;
  Phone1: string;
}

export default function carrierScoreCell(loadCarrierReviewScreen: (selectedCarrier: SelectedCarrierValue) => void) {
  return class CarrierScoreCell extends React.Component<GridCustomCellProps> {
    private getSelectedCarrierValue(carrier: AssetCarrierViewModel): SelectedCarrierValue {
      return {
        CarrierID: carrier.CarrierID,
        CarrierName: carrier.CarrierName,
        Phone1: carrier.Phone1,
      };
    }

    render() {
      const dataItem = this.props.dataItem as AssetCarrierViewModel;

      return (
        <td
          {...this.props.tdProps}
          style={{ cursor: "pointer", textAlign: "right" }}
          onClick={() => loadCarrierReviewScreen(this.getSelectedCarrierValue(dataItem))}
        >
          {dataItem.CarrierScore != null ? formatNumber(dataItem.CarrierScore, "n0") : ""}
        </td>
      );
    }
  }
}
